import React from "react"
import { useDispatch } from 'react-redux';
import { setSearchWindowOpen } from "../Actions/SearchWindow.action";

export default function NavigationSearchButton({ isMobile, buttonText }) {
    const dispatch = useDispatch()

    return <div onClick={() => dispatch(setSearchWindowOpen(true))}>
        <i className="icon icon-search"></i>
        {!isMobile ? buttonText : ""}
    </div>
}